export const getResourceFromSrn = (srn: string) => {
    const cleaned = srn.replace(/^srn:smash:/, '');
    const parts = cleaned.split(':').filter(p => p && !p.startsWith('$'));
    const tokens = parts.join(':').split('/').filter(Boolean);
    const resourceNames = tokens.filter(token => !token.startsWith(':'));
    const formatted = resourceNames
        .map(name => name.charAt(0).toUpperCase() + name.slice(1))
        .filter(name => name !== 'Account' && name !== 'Team' && name !== 'User')
        .join(' ');

    return formatted;
}
